// Modelo para guias proessat
export default class GuiaProessatData {
    id=""
    questionNumber=-1
    questionText=""
    answer=""
    guiaProessat=""
}



// WEBPACK FOOTER //
// ./src/model/GuiaProessatData.js